module.exports = __webpack_public_path__ + "img/Slovaška.e5bddd7e.png";